<template>
  <router-view />
</template>

<script>
import { mapState, mapActions } from "vuex";
import { client } from "@/api/client";
export default {
  computed: {
    ...mapState(["pageTitle"]),
    title() {
      return `BanniBook.com - Online Bookstore Terlengkap untuk referensi buku Digital Marketing di Indonesia `;
    },
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: "description", name: "description", content: "BanniBook.com - Online Bookstore Terlengkap untuk referensi buku Digital Marketing di Indonesia" },
        { vmid: "og:description", property: "og:description", content: "BanniBook.com - Online Bookstore Terlengkap untuk referensi buku Digital Marketing di Indonesia" },
        { vmid: "og:image", property: "og:image", content: `${process.env.VUE_APP_DOMAIN}/assets/icons/logo-banni.svg` },
        { vmid: "og:url", property: "og:url", content: `${process.env.VUE_APP_DOMAIN}` },
        { vmid: "og:title", property: "og:title", content: this.title },
      ]
    }
  },
  watch: {
    pageTitle(val, oldVal) {
      if (val !== oldVal) {
        document.title = this.title;
        document.getElementsByTagName("meta")["description"].content =
          "BanniBook.com - Online Bookstore Terlengkap untuk referensi buku Digital Marketing di Indonesia";
      }
    },
  },
  methods: {
    ...mapActions("auth", ["logout"]),

    forceLogout() {
      this.logout().then(() => {
        this.$router
          .push({ name: "login", query: { redirect: this.$route.fullPath } })
          .catch(() => {});
      });
    },
  },
  // async beforeMount() {
  // 		// await this.getSiteConfig();
  // 		// console.log("siteconf", this.siteConfig.favicon)
  // 		var link =
  // 		(await document.querySelector("link[rel*='icon']")) ||
  // 		document.createElement("link");
  // 		link.type = await "image/x-icon";
  // 		link.rel = await "shortcut icon";
  // 		link.href = '/favicon.ico';
  // 		await document.getElementsByTagName("head")[0].appendChild(link);
  // 	},
  created() {
    client.interceptors.response.use(undefined, (error) => {
      return new Promise(() => {
        if (error.response.status === 406) {
          this.forceLogout();
        }
        throw error;
      });
    });
  },
};
</script>

<style lang="scss">
@import "./styles/theme";
@import "./styles/page";
@import "./styles/responsive";
</style>
